import axiosNewApi from "config/axiosNewApi";

export const sendOrder = async ({
  orderReference,
  orderComment,
  shipping_address,
  shippingMethod,
  ip_creator,
  orderItems,
}) => {
  try {
    const payload = {
      orderReference,
      orderComment,
      shipping_address,
      shippingMethod,
      ip_creator,
      orderItems,
    };

    const response = await axiosNewApi.post("mobile/orders/send-order", payload, {
      withCredentials: true,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  } catch (error) {
    console.error("Error sending order:", error);
    throw error;
  }
};
